module.exports = __webpack_public_path__ + "img/LOCK.bef3469c.svg";